<template>
  <!-- <ValidationProvider tag="div" :rules="rules" :label="label" v-slot="{ errors }"> -->
      
  <div>
    <!-- {{filterObWatchList.via}} -->
    <div
      v-for="(stop, index) in options"
      :key="index+'ob'"
      role="group"
      class="custom-control custom-radio option"
     
    >
      <!-- <input
        :id="stop.name"
        type="radio"
        class="custom-control-input"
        @click="emitValue(stop)"
        :value="stop.name"
        :checked="selStopsNameLs.includes(stop.name)"
      /> -->

       <input
        :id="stop.name+'ob'"
        type="radio"
        class="custom-control-input"
        @click="emitValue(stop)"
        :value="stop" 
        v-model="selValueModel"
        
      />
      <label :for="stop.name+'ob'" class="click"></label>
      <label :for="stop.name+'ob'" class="custom-control-label">
       {{stop.code!=0 &&stop.code!=1 ?stop.name+' '+$t('flightResults.fewer'):stop.name }}
        </label>
    </div>
  </div>

  <!-- <div  v-if="errors && errors[0]" class="invalid-feedback icon">
        <div v-show="!selValueModel">
          <span>{{ errors[0] }}</span>
        </div>
  </div>-->
  <!-- </div> -->
  <!-- </ValidationProvider> -->
</template>

<script>
import router, { navigate, goBack } from "../../router/index";
import { ValidationProvider } from "vee-validate";
import Multiselect from "vue-multiselect";
import { FILTERSTOPS, FILTER } from "../../util/constants.js";
import { mapGetters, mapActions } from "vuex";
import { PATHNAME, COMPONENT_NAME } from "../../util/constants.js";
import BaseConfiguration from "../../config/base.js";
import {
  VALIDATE_SUCCESS_RES,
  getErrorMessage
} from "../../util/apiValidate.js";
import { handleJWT, getErrorAlertValue } from "../../util/util";
import SERVICE_URL from "../../config/API_DATA";
import Logger from "../../services/logger";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../config/API_DATA";
export default {
  name: COMPONENT_NAME.C_FILTER_VIA_OB,
  components: {
    ValidationProvider,
    Multiselect
  },
  model: {
    prop: "selValue"
  },

  props: {
   
    filterObWatList: {
      type: Object
    },
    selValue: {
      type: Object | Array,
      default: null
    },
  },
  data: () => ({
     options: [],
    selValueModel: null,
    filterObWatchList: {},
    selStopsNameLs: [],
    selectedStopLs: []
    // agencyDet: null
  }),

  watch: {
    // selValueModel(val) {
    //   if (val !== this.selValueModel) {
    //     this.selValueModel = val;
    //   }
    // },
    filterObWatList:{
        immediate: false, 
        deep: true,
    handler: function (newVal, oldVal) {
      // if(oldVal==newVal||oldVal!=newVal){
      this.filterObWatchList = this.filterObWatList;
      this.options=this.filterObWatchList[FILTER.C_FILTER_VIA];
      this.selectedStopLs = this.filterObWatchList[FILTER.C_FILTER_VIA];
      
      if(this.filterObWatchList[FILTER.C_FILTER_VIA] && 
      this.filterObWatchList[FILTER.C_FILTER_VIA][0].status==1 )
       {
      this.selValueModel = this.filterObWatchList[FILTER.C_FILTER_VIA][0];
    }
      }
        
      // }
      },
    
  },

  async created() {
    try {
      if (BaseConfiguration.isDebug) console.log(" created");
      this.filterObWatchList = this.filterObWatList;
      this.options=this.filterObWatchList[FILTER.C_FILTER_VIA];
      // this.selValueModel=this.selValue;
      // this.selValueModel = this.filterObWatchList[FILTER.C_FILTER_VIA][0];
      this.selectedStopLs = this.filterObWatchList[FILTER.C_FILTER_VIA];
      for (let i = 0; i < this.selectedStopLs.length; i++) {
          if (this.selectedStopLs[i].status == 1) {
            this.selValueModel=this.selectedStopLs[i];
          }
          
        }
     if (BaseConfiguration.isDebug) console.log(this.selValueModel);

    } catch (err) {
      let body = Logger.buildRequest(
        COMPONENT_NAME.C_FILTER_VIA_OB,
        "error while Component created",
        err.toString(),
        "created",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
  },

  computed: {},

  methods: {
    
    emitValue(pselValueModel) {
 for (let i = 0; i < this.selectedStopLs.length; i++) {
          if (this.selectedStopLs[i].name == pselValueModel.name) {
            this.selectedStopLs[i].by='user';
         this.selectedStopLs[i].status=1
           
          } else{
              this.selectedStopLs[i].by='user';
         this.selectedStopLs[i].status=0
           
          }
          
        }
        // console.log(this.selectedStopLs);
      // if (this.selectedStopLs.length > 0) {
       
      //   let isDup = false;
      //   let dulIndex = null;
      //   for (let i = 0; i < this.selectedStopLs.length; i++) {
      //     if (this.selectedStopLs[i].name == pselValueModel.name) {
      //       isDup = true;
      //       dulIndex = i;
      //     }
      //   }
      //   if (isDup) {
      //     this.$delete(this.selectedStopLs, dulIndex);
      //   } else {
      //     this.selectedStopLs.push(pselValueModel);
      //   }
      // } else {
      //   this.selectedStopLs.push(pselValueModel);
      // }

      // this.selStopsNameLs = [];
      // for (let j = 0; j < this.selectedStopLs.length; j++) {
      //   this.selStopsNameLs.push(this.selectedStopLs[j].name);
      // }

      // let retFilStops = this.filterObFlights(
      //   this.flightResult,
      //   this.selectedStopLs
      // );
      this.$emit(
        "input",
   
        this.selectedStopLs,
        FILTER.C_FILTER_VIA,
       
      );
    },

    
    // ///to get filtered ob flights
    // filterObFlights(pObFlights, pSelStop) {
    //   let retValue = [];
    //   try {
    //     if (BaseConfiguration.isDebug) console.log("filterObFlights");

    //     // console.log(Object.keys(this.airlines)[0]);
    //     for (let i = 0; i < Object.keys(pObFlights).length; i++) {
    //       for (let j = 0; j < pSelStop.length; j++) {
    //         if (
    //           pSelStop[j].code ==
    //           Object.values(pObFlights)[i][0].obFlight.length - 1
    //         ) {
    //           retValue.push(Object.values(pObFlights)[i]);
    //         }
    //       }
    //     }
    //     console.log(retValue + "ret");
       
    //     return retValue;
    //   } catch (err) {
    //     let body = Logger.buildRequest(
    //       COMPONENT_NAME.C_FILTER_STOPS_OB,
    //       "error in filterObFlights",
    //       err.toString(),
    //       "filterObFlights",
    //       LOG_TYPE.ERROR
    //     );
    //     Logger.getResponse(body);
    //   }
    //   return retValue;
    // }

    
  },
  // mounted() {
  //   this.$root.$on(
  //     "cFilterStopsObFn",
  //     (pSelFilterStop, pFlightRes, pWatchList) => {
  //       let watchList = pWatchList;
  //       this.$delete(watchList, FILTER.C_FILTER_STOPS);

  //       let retFilStops = this.filterObFlights(pFlightRes, pSelFilterStop);
  //       this.$emit(
  //         "input",
  //         retFilStops,
  //         pSelFilterStop,
  //         FILTER.C_FILTER_STOPS,
  //         watchList
  //       );
  //     }
  //   );
  // }
};
</script>


